import { ScrollText } from 'lucide-react';

import type { SystemPrompt } from '@/features/votes/message-votes';

import CollapsibleBlock from './CollapsibleBlock';

interface SystemPromptBlockProps {
  prompt: SystemPrompt;
}

export default function SystemPromptBlock({ prompt }: SystemPromptBlockProps) {
  const dynamicStart = prompt.dynamic_start;
  const sections =
    dynamicStart === null
      ? [
          {
            label: 'System prompt',
            text: prompt.text,
          },
        ]
      : [
          // Static first: it is the cached prefix and precedes the dynamic part on the wire
          {
            label: 'Static system prompt',
            text: prompt.text.slice(0, dynamicStart),
          },
          {
            label: 'Dynamic system prompt',
            text: prompt.text.slice(dynamicStart),
          },
        ];

  return (
    <div className="space-y-2">
      {sections.map(
        (section) =>
          section.text && (
            <CollapsibleBlock
              key={section.label}
              icon={<ScrollText className="h-3.5 w-3.5" />}
              label={section.label}
              tone="purple"
            >
              <pre className="max-h-96 overflow-auto whitespace-pre-wrap break-words rounded bg-background/70 p-2 font-mono text-xs leading-relaxed">
                {section.text}
              </pre>
            </CollapsibleBlock>
          )
      )}
    </div>
  );
}
